import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import BackMethods from "../../back_component/BackMethods";
import {
    FaPlus, FaEdit, FaTrash, FaLayerGroup,
    FaCheckCircle, FaTimesCircle, FaArrowRight,
    FaSearch, FaFilter, FaSortAmountDown
} from "react-icons/fa";

export default function PriceSurveyCategoriesPage() {
    const { backEnd_request } = BackMethods();
    const navigate = useNavigate();

    const [loading, setLoading] = useState(false);
    const [categories, setCategories] = useState([]);

    // حالات التصفية والبحث
    const [searchTerm, setSearchTerm] = useState("");
    const [statusFilter, setStatusFilter] = useState("all");

    // حالات المودال (النافذة المنبثقة)
    const [showModal, setShowModal] = useState(false);
    const [isEdit, setIsEdit] = useState(false);
    const [currentCategory, setCurrentCategory] = useState({
        name: "",
        displayOrder: 0,
        isActive: true
    });

    const loadCategories = async () => {
        setLoading(true);
        try {
            // المسار المعتمد في الصورة المرفقة
            const response = await backEnd_request.get("/PriceSurveyProductCategories");
            setCategories(response.data);
        } catch (err) {
            console.error("Error loading categories:", err);
        } finally {
            setLoading(false);
        }
    };

    useEffect(() => { loadCategories(); }, []);

    // --- منطق الفلترة والبحث ---
    const filteredCategories = categories.filter(item => {
        const matchesSearch = item.name.toLowerCase().includes(searchTerm.toLowerCase());
        const matchesStatus = statusFilter === "all" ? true :
            statusFilter === "active" ? item.isActive === true :
                item.isActive === false;

        return matchesSearch && matchesStatus;
    }).sort((a, b) => a.displayOrder - b.displayOrder); // ترتيب حسب ترتيب العرض

    const handleDelete = async (id) => {
        if (window.confirm("هل أنت متأكد من حذف هذا التصنيف؟")) {
            try {
                await backEnd_request.delete(`/PriceSurveyProductCategories/${id}`);
                setCategories(categories.filter(c => c.categoryId !== id));
            } catch (err) {
                alert("حدث خطأ أثناء الحذف، قد يكون التصنيف مرتبطاً بمواد.");
            }
        }
    };

    const handleSave = async (e) => {
        e.preventDefault();
        try {
            if (isEdit) {
                await backEnd_request.post(`/PriceSurveyProductCategories/${currentCategory.categoryId}`, currentCategory);
            } else {
                await backEnd_request.post("/PriceSurveyProductCategories", currentCategory);
            }
            setShowModal(false);
            loadCategories();
            setCurrentCategory({ name: "", displayOrder: 0, isActive: true });
        } catch (err) {
            alert("خطأ في حفظ البيانات، يرجى المحاولة مرة أخرى");
        }
    };

    return (
        <div className="bg-light min-vh-100 py-4" dir="rtl">
            <div className="container shadow-sm bg-white rounded-4 p-4">

                {/* الرأس - Header */}
                <div className="d-flex flex-column flex-md-row justify-content-between align-items-md-center mb-4 pb-3 border-bottom gap-3">
                    <div>
                        <h3 className="fw-bold text-primary mb-1">
                            <FaLayerGroup className="ms-2" /> تصنيفات المواد
                        </h3>
                        <p className="text-muted small mb-0">إجمالي التصنيفات: {filteredCategories.length}</p>
                    </div>
                    <div className="d-flex gap-2">
                        <button
                            onClick={() => {
                                setIsEdit(false);
                                setCurrentCategory({ name: "", displayOrder: categories.length, isActive: true });
                                setShowModal(true);
                            }}
                            className="btn btn-primary d-flex align-items-center px-4 rounded-pill shadow-sm"
                        >
                            <FaPlus className="ms-2" /> إضافة تصنيف
                        </button>
                        <button onClick={() => navigate(-1)} className="btn btn-outline-secondary rounded-pill">
                            <FaArrowRight className="ms-1" /> رجوع
                        </button>
                    </div>
                </div>

                {/* قسم التصفية والبحث */}
                <div className="row g-3 mb-4 bg-light p-3 rounded-3 border">
                    <div className="col-md-8">
                        <div className="input-group border rounded-pill bg-white px-3 py-1">
                            <span className="input-group-text bg-transparent border-0 text-muted"><FaSearch /></span>
                            <input
                                type="text"
                                className="form-control border-0 bg-transparent shadow-none"
                                placeholder="ابحث باسم التصنيف..."
                                value={searchTerm}
                                onChange={(e) => setSearchTerm(e.target.value)}
                            />
                        </div>
                    </div>
                    <div className="col-md-4">
                        <div className="input-group border rounded-pill bg-white px-3 py-1">
                            <span className="input-group-text bg-transparent border-0 text-muted"><FaFilter /></span>
                            <select
                                className="form-select border-0 bg-transparent shadow-none"
                                value={statusFilter}
                                onChange={(e) => setStatusFilter(e.target.value)}
                            >
                                <option value="all">جميع الحالات</option>
                                <option value="active">نشط فقط</option>
                                <option value="inactive">متوقف فقط</option>
                            </select>
                        </div>
                    </div>
                </div>

                {/* عرض البيانات */}
                {loading ? (
                    <div className="text-center py-5"><div className="spinner-border text-primary"></div></div>
                ) : (
                    <div className="table-responsive">
                        <table className="table table-hover align-middle border-light">
                            <thead className="table-light">
                                <tr>
                                    <th className="py-3 border-0">اسم التصنيف</th>
                                    <th className="py-3 border-0 text-center">ترتيب العرض</th>
                                    <th className="py-3 border-0 text-center">الحالة</th>
                                    <th className="py-3 border-0 text-center">إجراءات</th>
                                </tr>
                            </thead>
                            <tbody>
                                {filteredCategories.map((item) => (
                                    <tr key={item.categoryId}>
                                        <td className="fw-bold text-dark py-3">{item.name}</td>
                                        <td className="text-center">
                                            <span className="badge bg-secondary-subtle text-secondary border px-3 py-2 rounded-pill fw-normal">
                                                <FaSortAmountDown className="ms-1" /> {item.displayOrder}
                                            </span>
                                        </td>
                                        <td className="text-center">
                                            {item.isActive ? (
                                                <span className="badge bg-success-subtle text-success border border-success-subtle px-3 py-2 rounded-pill fw-normal">
                                                    <FaCheckCircle className="ms-1" /> نشط
                                                </span>
                                            ) : (
                                                <span className="badge bg-danger-subtle text-danger border border-danger-subtle px-3 py-2 rounded-pill fw-normal">
                                                    <FaTimesCircle className="ms-1" /> متوقف
                                                </span>
                                            )}
                                        </td>
                                        <td className="text-center">
                                            <div className="btn-group shadow-sm bg-white rounded-3">
                                                <button
                                                    onClick={() => { setCurrentCategory(item); setIsEdit(true); setShowModal(true); }}
                                                    className="btn btn-outline-primary btn-sm border-0 px-3"
                                                >
                                                    <FaEdit />
                                                </button>
                                                <button
                                                    onClick={() => handleDelete(item.categoryId)}
                                                    className="btn btn-outline-danger btn-sm border-0 px-3"
                                                >
                                                    <FaTrash />
                                                </button>
                                            </div>
                                        </td>
                                    </tr>
                                ))}
                            </tbody>
                        </table>

                        {filteredCategories.length === 0 && (
                            <div className="text-center py-5 border-top">
                                <p className="text-muted mb-0">لا توجد تصنيفات مطابقة للبحث</p>
                            </div>
                        )}
                    </div>
                )}
            </div>

            {/* Modal - إضافة وتعديل التصنيف */}
            {showModal && (
                <div className="modal show d-block" style={{ backgroundColor: 'rgba(0,0,0,0.5)', backdropFilter: 'blur(4px)' }}>
                    <div className="modal-dialog modal-dialog-centered">
                        <div className="modal-content border-0 shadow-lg rounded-4">
                            <div className="modal-header border-0 pt-4 px-4">
                                <h5 className="fw-bold">{isEdit ? "تعديل التصنيف" : "إضافة تصنيف جديد"}</h5>
                                <button type="button" className="btn-close" onClick={() => setShowModal(false)}></button>
                            </div>
                            <form onSubmit={handleSave}>
                                <div className="modal-body p-4">
                                    <div className="mb-3">
                                        <label className="form-label small fw-bold">اسم التصنيف</label>
                                        <input
                                            type="text" className="form-control rounded-3"
                                            value={currentCategory.name}
                                            onChange={(e) => setCurrentCategory({ ...currentCategory, name: e.target.value })}
                                            required
                                        />
                                    </div>
                                    <div className="mb-3">
                                        <label className="form-label small fw-bold">ترتيب العرض (رقمي)</label>
                                        <input
                                            type="number" className="form-control rounded-3"
                                            value={currentCategory.displayOrder}
                                            onChange={(e) => setCurrentCategory({ ...currentCategory, displayOrder: parseInt(e.target.value) })}
                                            required
                                        />
                                    </div>
                                    <div className="form-check form-switch mt-3">
                                        <input
                                            className="form-check-input" type="checkbox"
                                            checked={currentCategory.isActive}
                                            onChange={(e) => setCurrentCategory({ ...currentCategory, isActive: e.target.checked })}
                                        />
                                        <label className="form-check-label fw-bold small">التصنيف نشط حالياً</label>
                                    </div>
                                </div>
                                <div className="modal-footer border-0 p-4 pt-0">
                                    <button type="button" className="btn btn-light rounded-3 px-4" onClick={() => setShowModal(false)}>إغلاق</button>
                                    <button type="submit" className="btn btn-primary rounded-3 px-4">حفظ البيانات</button>
                                </div>
                            </form>
                        </div>
                    </div>
                </div>
            )}
        </div>
    );
}